import { callAllHandlers } from "@smartsheet/lodestar-utils";
import { useMemo, useState } from "react";
export const useHovered = function () {
  let {
    onMouseEnter: providedOnMouseEnter,
    onMouseLeave: providedOnMouseLeave
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [isHovered, setIsHovered] = useState(false);
  const onMouseEnter = useMemo(() => callAllHandlers(providedOnMouseEnter, () => {
    setIsHovered(true);
  }), [providedOnMouseEnter]);
  const onMouseLeave = useMemo(() => callAllHandlers(providedOnMouseLeave, () => {
    setIsHovered(false);
  }), [providedOnMouseLeave]);
  const result = {
    isHovered,
    onMouseEnter,
    onMouseLeave
  };
  return result;
};
//# sourceMappingURL=useHovered.js.map